<template>
	<div
		class="profile-switcher-widget"
		:class="{
			collapsedProfilePadding: !expandedMenu,
			centerProfileImage: !expandedMenu,
		}"
	>
		<section
			class="current-profile"
			role="button"
			tabindex="0"
			@click="
				canPerformSelector && expandedMenu
					? toggleExpandedProfileSelector()
					: ''
			"
			:class="{
				'profile-information-cursor': canPerformSelector && expandedMenu,
			}"
		>
			<img
				v-if="
					profile.profilePhoto != null && profile.profilePhoto.imageUri !== ''
				"
				:src="profile.profilePhoto.imageUri"
				:alt="preferredName"
			/>
			<img v-else src="@/assets/default-headshot.png" :alt="preferredName" />
			<div class="profile-wrapper">
				<div class="profile-information">
					<span role="heading" aria-level="2" class="profile-name">
						{{ preferredName }}
					</span>
					<span role="heading" aria-level="3" class="profile-company">
						{{ preferredCompanyName }}</span
					>
				</div>
				<button
					class="profile-selector-btn"
					v-if="canPerformSelector"
					:class="{ open: expandedProfileSelector }"
				>
					<font-awesome-icon
						class="branch-toggle"
						:icon="['fal', 'chevron-circle-down']"
					/>
				</button>
			</div>
		</section>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
	name: 'ProfileSwitcherWidget',
	props: {
		msg: String,
	},
	computed: mapState({
		expandedMenu: (state) => state.menus.expandedMenu,
		expandedProfileSelector: (state) => state.menus.expandedProfileSelector,
		profile: (state) => state.profile,
		profileSelector: (state) => state.profileSwitcher.profileSelector,
		canPerformSelector: (state) =>
			state.profileSwitcher.mainProfileSelector.canPerformProfileSelector,
		preferredName: (state) => {
			if (
				state.profileSwitcher.profileSelector.userPreferredName !== null &&
				state.profileSwitcher.profileSelector.userPreferredName !== ''
			)
				return state.profileSwitcher.profileSelector.userPreferredName;
			return '';
		},
		preferredCompanyName: (state) => {
			if (
				state.profileSwitcher.profileSelector.userCompanyName !== null &&
				state.profileSwitcher.profileSelector.userCompanyName !== ''
			)
				return state.profileSwitcher.profileSelector.userCompanyName;
			return '';
		},
		fullName: (state) => `${state.profile.firstName} ${state.profile.lastName}`,
		profilePhoto: (state) => {
			if (
				state.profileSwitcher.profileSelector.profileLogo !== null &&
				state.profileSwitcher.profileSelector.profileLogo.imageUri !== ''
			)
				return state.profileSwitcher.profileSelector.profileLogo.imageUri;
			if (
				state.profile.profilePhoto !== null &&
				state.profile.profilePhoto.imageUri !== null
			)
				return state.profile.profilePhoto.imageUri;
			return '';
		},
		profileCompanyName: (state) => {
			if (
				state.profile.associatedBrokerShops != null &&
				state.profile.associatedBrokerShops.length > 0
			)
				return state.profile.associatedBrokerShops[0].brokerName;
			return '';
		},
	}),
	methods: {
		...mapActions(['toggleExpandedSmallNav', 'toggleExpandedProfileSelector']),
	},
};
</script>

<style scoped lang="scss">
.profile-switcher-widget {
	border-bottom: $border-width solid $border-color-light;
	width: 100%;
	box-sizing: border-box;
	padding: 18px 15px;
	display: flex;
	align-items: center;
	.profile-information-cursor {
		cursor: pointer;
	}

	.current-profile {
		display: flex;
		width: 100%;
		outline: none;
	}

	img {
		border-radius: $border-radius;
		width: 44px;
		height: 44px;
	}

	.profile {
		&-wrapper {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;
			.branch-toggle {
				color: $brand-blue;
			}

			.profile-selector-btn {
				border: unset;
				background: unset;
				padding: unset;
				transition: transform 0.5s ease-in-out;
				&:active {
					outline: unset;
				}

				&.open {
					transform: rotate(180deg);
				}
			}
		}

		&-information {
			display: flex;
			flex-direction: column;
			padding-left: $base-padding;
			transition: all 1s ease-in;
			overflow: visible;
		}

		&-name {
			width: 150px;
		}

		&-company {
			color: $subheader-color;
			@include rem(font-size, 10px);
			width: 150px;
		}
	}

	.collapsedProfile {
		@include lg {
			transition: $b360-motion-all--3s-in-out;
			display: none;
			color: $white;

			.profile-name,
			.profile-company {
				transition: $b360-motion-all--3s-in-out;
				display: none;
				color: $white;
				width: 0px;
			}
		}
	}
}

.collapsedProfilePadding {
	@include lg {
		transition: $b360-motion-all--3s-in-out;
		height: $context-nav-height;
		display: flex;
		align-items: center;
	}
}

.centerProfileImage {
	@include lg() {
		@include flex-center;
	}
}
</style>
